import Api from '@/services/Api'

export default {
  fetchGuests (id) {
    return Api().get('/company/' + id + '/users')
  },

  // Admin
  getAll () {
    return Api().get('/users')
  },
  getAllCovid (id) {
    return Api().get('/users/covid/' + id)
  },
  create (data) {
    return Api().post('/users', data)
  },
  edit (data) {
    return Api().put('/users/' + data.id, data)
  },
  delete (data) {
    return Api().delete('/users/' + data.id)
  },
}
